import React, { useCallback } from 'react';
import { LIST_ITEMS_SIZE } from 'config';
import withScrollHack from 'components/HOCs/withScrollHack';
import SpatialNavigationWrapper from 'components/navigation/SpatialNavigationWrapper';
import { LIST_ITEM_MARGIN, ListItemCleanWrapper } from 'components/ListItem';
import PropTypes from 'prop-types';
import SearchCategories from './SearchCategories';
import { StyledSearchResultsList } from './StyledComponents';

const CONTENT_SECTION_NAME = 'SEARCH_RESULTS';
const CONTENT_SIZE = LIST_ITEMS_SIZE.SEARCH.width + LIST_ITEM_MARGIN;

const listConfig = {
  enterTo: 'last-focused',
  leaveFor: {
    right: '',
    down: '@KEYBOARD',
  },
  debounce: {
    time: 200,
    options: {
      leading: true,
      trailing: false,
      maxWait: 200,
    },
  },
};

const SearchResult = (props) => {
  const { results, onItemEnter, onCategoryEnter } = props;
  const { previewItems } = results;

  const onWheel = useCallback(({ deltaY }) => {
    const direction = deltaY > 0 ? 'right' : 'left';
    SpatialNavigationWrapper.focus(`@${CONTENT_SECTION_NAME}`);
    SpatialNavigationWrapper.move(direction);
  }, []);

  return (
    <>
      <SearchCategories onEnter={onCategoryEnter} />
      <StyledSearchResultsList
        sectionName={CONTENT_SECTION_NAME}
        onWheel={onWheel}
        items={previewItems}
        onEnter={onItemEnter}
        config={listConfig}
        listId={'search-results'}
        itemSize={CONTENT_SIZE}
        renderSize={14}
        startScrollIndex={7}
        itemRender={(props) => (
          <ListItemCleanWrapper {...props} itemSize={LIST_ITEMS_SIZE.SEARCH} />
        )}
      />
    </>
  );
};

SearchResult.propTypes = {
  results: PropTypes.shape({
    totalElements: PropTypes.number.isRequired,
    content: PropTypes.array.isRequired,
    previewItems: PropTypes.array.isRequired,
    previewItemsCount: PropTypes.number.isRequired,
  }),
  onItemEnter: PropTypes.func.isRequired,
  onCategoryEnter: PropTypes.func.isRequired,
};

export default withScrollHack(SearchResult);
